// BereichUmschalter.tsx — T-56: „Alle / Team / Eigene" in den Vorgangs-Pickern.
//
// Dieselbe Leiste und dieselbe Bedeutung wie auf der Vorgänge-Seite
// (`VorgaengeMo` → `scopeBar`): Optik `rbac-seg`, Optionen aus `SCOPE_OPTIONS`,
// „Team" nur mit Teamzugehörigkeit. Der Server filtert mit derselben Regel wie
// der Feed (`bereichFilterSql`). Bewusst OHNE das Rechtsklick-Menü „Als
// Standard speichern" — im Popup gilt immer „Alle" beim Öffnen.

import * as React from "react";
import { useAuth } from "../../../context/AuthContext";
import { bereichOptionen, type ScopeKey } from "../../../utils/vorgangScope";

export interface BereichUmschalterProps {
    wert: ScopeKey;
    onChange: (bereich: ScopeKey) => void;
    /** Ohne Team gibt es den Punkt „Team" nicht. */
    hatTeam: boolean;
    disabled?: boolean;
}

export const BereichUmschalter: React.FC<BereichUmschalterProps> = ({
    wert,
    onChange,
    hatTeam,
    disabled = false,
}) => (
    <div className="rbac-seg vgp-bereich" role="group" aria-label="Bereich">
        {bereichOptionen(hatTeam).map((o) => (
            <button
                key={o.key}
                type="button"
                className={"rbac-seg-btn" + (wert === o.key ? " on" : "")}
                aria-pressed={wert === o.key}
                disabled={disabled}
                onClick={() => onChange(o.key)}
            >
                <span className="rbac-dot" />
                {o.label}
            </button>
        ))}
    </div>
);

/**
 * Variante, die die Teamzugehörigkeit selbst aus der Sitzung liest. Eigene
 * Komponente, damit `useAuth` nur dort läuft, wo der Umschalter auch gezeigt
 * wird — die übrigen Picker (und ihre Tests) brauchen keinen AuthProvider.
 */
export const BereichUmschalterMitAuth: React.FC<Omit<BereichUmschalterProps, "hatTeam">> = (props) => {
    const { teams } = useAuth();
    return <BereichUmschalter {...props} hatTeam={(teams?.length ?? 0) > 0} />;
};

export default BereichUmschalter;
